/**
 * P3-15 · Match emphasis for suggestion labels (P3-DB04 §03 — "the matched
 * substring is emphasised in each label").
 *
 * Token-based and case-insensitive: each query token of ≥2 chars is wrapped in
 * a <mark> wherever it appears, so "field jacket" highlights both words in
 * "Waxed Field Coat". Purely presentational — the emphasis is not the sole
 * carrier of meaning (the full label is still read).
 */
import * as React from "react";

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function highlightMatch(
  text: string,
  query: string,
): React.ReactNode {
  const tokens = query
    .trim()
    .split(/\s+/)
    .filter((t) => t.length >= 2)
    .map(escapeRegExp);
  if (tokens.length === 0) return text;

  const re = new RegExp(`(${tokens.join("|")})`, "gi");
  const parts = text.split(re);
  return parts.map((part, i) =>
    // Odd indices are the captured matches (split with a capture group
    // interleaves match/non-match).
    i % 2 === 1 ? (
      <mark
        key={i}
        className="rounded-[3px] bg-fg/10 font-medium text-fg"
      >
        {part}
      </mark>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    ),
  );
}
